module.exports = {
    API_TITLE:"企业定额标前成本智能测算系统", //项目名称
    testdomainName:"https://cost.jiuju.xinyikeji.com.cn/", //测试域名
    domainName:"https://cost.jiuju.xinyikeji.com.cn/", //正式域名
    interfacePrefix:"ceapi/", //接口前缀
    port:8060, //本地端口
    assetsPublicPath:"/", //打包后服务器文件路径
}


//////////////////
// WEBPACK FOOTER
// ./vue.config.js
// module id = D/cJ
// module chunks = 18